import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class DefaultController {

  constructor(app) {

    this.app = app;
    this.searchStatus = null;
  }
  show(path, model) {

    this.load();

    const swapPage = new SwapPage();
    swapPage.swapPage("FindPlayer");
  }
  populate() {
    const app = this.app;
    const userdata = app.userdata;
    const friends = userdata.friends || [];
    const blockedPlayers = userdata.blockedPlayers || [];
    const blockedPlayersCount = blockedPlayers.length + "";

    const model = {
      userdata: userdata,
      friends: friends,
      blockedPlayersCount: blockedPlayersCount,
      searchStatus: this.searchStatus
    }

    const dataBinder = new DataBinder();
    dataBinder.populate("FindPlayer", model);
  }
  load() {
    const app = this.app;
    const userdata = app.userdata;
    const recentUsers = userdata.recentUsers || [];
    let friends = userdata.friends || [];

    //merge recentUsers and friends
    friends = friends.concat(recentUsers);
    userdata.recentUsers = [];
    userdata.friends = friends;


    this.populate();

    // //get facebook friends
    // //?add recent players using FBInstant.context.getPlayersAsync()
    // FBInstantGame.getPlayers()
    //   .then(function (users) {
    //     $scope.friends = users;
    //     $scope.$apply();
    //   });


  }
  showToast(message) {
    this.app.showToast(message);
  }
  findPlayer(search) {
    this.searchStatus = "Searching...";
    this.populate();

    let value = parseInt(search, 10);
    //serach by Id
    if (value) {
      let id = value;
      this.findPlayerById(id);
    }
    //search by email
    if (!value) {
      let email = search;
      this.findPlayerByEmail(email);
    }
  }

  findPlayerById(id) {
    return this.app.gamification.GetUser(id).then(function (user) {
      this.searchStatus = null;
      this.populate();
      if (!user) {
        this.showToast("No user found");
        return;
      }
      const friend = {
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      }
      this.addFriend(friend);

    }.bind(this));
  }
  findPlayerByEmail(email) {
    return this.app.gamification.FindUser(null, null, email).then(function (user) {
      this.searchStatus = null;
      this.populate();
      if (!user) {
        this.showToast("No user found");
        return;
      }
      const friend = {
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      }
      this.addFriend(friend);
    }.bind(this));
  }
  removeFriend(id) {
    const app = this.app;
    const userdata = app.userdata;

    let friends = userdata.friends;
    userdata.friends = friends.filter(function (obj) {
      return obj.id != id;
    });


    this.populate();
  }
  addFriend(user) {
    const app = this.app;
    const userdata = app.userdata;

    if (!user) return;
    if (!user.id) return;

    let friends = userdata.friends || [];
    let existingFriends = friends.filter(function (f) {
      return f.id === (user.Id || user.id)
    });

    let friend = existingFriends[0];
    if (!friend) { //add new
      friends.push({
        id: user.id,
        avatar: user.avatar,
        name: user.name,
        facebookId: user.facebookId,
        trusted: user.trusted
      });
      this.showToast(user.name + " added to friends list")
    } else { //update
      friend.id = user.id;
      friend.avatar = user.avatar;
      friend.name = user.name;
      friend.facebookId = user.facebookId;
      friend.trusted = user.trusted;
    }


    this.populate();
  }
  clearblockPlayers() {
    const app = this.app;
    const userdata = app.userdata;
    const gameServer = app.gameServer;

    userdata.blockedPlayers = [];

    //update socket server data
    if (gameServer) gameServer.login(this.userdata);

    app.showToast("Reset blocked players")
    this.populate();
  }
  invitePlayer(toUserId, facebookId, isTrusted, room) {
    const app = this.app;
    const userdata = app.userdata;
    const gamification = app.gamification;

    //create room here
    if (!room && userdata && userdata.id) room = userdata.id + "";
    if (!room) room = Math.floor(Math.random() * Math.floor(100000000)) + "";

    const name = userdata && userdata.name;
    const fromUserId = userdata && userdata.id;
    const serverUrl = userdata.gameServer || "";

    //send invite push notification
    gamification.InviteSend(fromUserId, toUserId, room, serverUrl)
      .then(function (sent) {
        if (sent) {
          this.showToast("Invite sent via Push Notification");
          app.joinCustomRoom(room, serverUrl);
        } else {
          this.showToast("Invite failed to send");
        }
      }.bind(this));


    //this.showToast("Invite sent.");

    //todo: add socket invite

    //join room
    //$window.location.href = "#/Game/Online/" + roomName;
    //window.location.href = "#/Game/Online/" + room + "/" + serverUrl;

    //  //send facebook invite (only works if the user is on facebook instant game)
    //  if (user.facebookId) {
    //      FBInstantGame.invitePlayer(user.facebookId, roomName, userName, serverUrl);
    //  }


  }

  // $scope.FindByFacebook = function () {
  //   //todo: link to classic facebook friends page

  //   //show popup with all friends
  //   let roomName = USERDATA.id;
  //   let userName = USERDATA.name;
  //   FBInstantGame.inviteSend(roomName, userName).then(function (userData) {
  //       //get user
  //       $scope.InviteToPlay(userData);
  //   });
}

